import { sendClickLog } from '../../utils/sendClickLog';
import { WeblogPageCategory, WeblogScreenName } from '../../../shared/constants/weblog';
import media from '../../../shared/utils/mediaQuery';
import DomainManager from '../../../shared/utils/DomainManager';

import styled from '@emotion/styled';
import { useLayoutHeaderContext } from '../../../modules/LayoutHeaderContext';
import { resetButton } from '../../../styles/reset';
import Icon from '../../../shared/designSystem/components/Icon';
import { useEnvContext } from '../../../modules/EnvProvider';
import { S3_RESOURCE_LOGOS } from '../../../shared/designSystem/constants';

export default function GnbLogo() {
  const { theme } = useLayoutHeaderContext();
  const { targetEnv } = useEnvContext();
  const domainManager = new DomainManager(targetEnv);

  const logoName = theme === 'white' ? 'logo_mrt_v2_web' : 'logo_mrt_v2_web_white';

  const handleClick = () => {
    sendClickLog({
      eventName: 'mainlogo',
      screenName: WeblogScreenName.COMMON,
      pageCategory: WeblogPageCategory.COMMON,
    });

    window.location.href = `${domainManager.getTravelerServiceDomain()}`;
  };

  return (
    <Container>
      <Anchor type="button" onClick={handleClick}>
        <LogoImage baseUrl={S3_RESOURCE_LOGOS} name={logoName} alt="myrealtrip" />
      </Anchor>
    </Container>
  );
}

const Container = styled.div``;

const Anchor = styled.button`
  ${resetButton};
`;

const LogoImage = styled(Icon)`
  width: 128px;
  vertical-align: middle;

  ${media.mobile} {
    width: 92px;
  }
`;
